module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-process"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.procs && _vm.info.procs.length !== 0),
      expression: "info.procs && info.procs.length !== 0"
    }],
    staticClass: "result"
  }, [_c('div', {
    staticClass: "product-head"
  }, [_c('span', {
    staticClass: "product-name pull-left"
  }, [_vm._v(_vm._s(_vm.info.productName))]), _c('span', {
    staticClass: "time pull-left"
  }, [_vm._v("签约日期：" + _vm._s(_vm.info.signDate))])]), _vm._v(" "), _c('table', {
    staticClass: "order-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.info.procs), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "table-body"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.step))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.finishTime))])])
  })], 2)]), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.procs || _vm.info.procs.length === 0),
      expression: "!info.procs || info.procs.length === 0"
    }],
    attrs: {
      "height": 400,
      "is-no-more": _vm.noResult
    }
  }, [_c('div', {
    staticClass: "no-result",
    slot: "nomore"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/noresult.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [_c('p', [_vm._v("未查询到符合条件的借款进程...")]), _vm._v(" "), _c('p', [_vm._v("如有疑问可拨打 400-770-5127 咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "table-head"
  }, [_c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', [_vm._v("当前步骤")]), _vm._v(" "), _c('th', [_vm._v("完成时间")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-fc3f5a22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-process.vue
// module id = 631
// module chunks = 1